export const postCategory = async (
  auth: string,
  categoryName: string,
  icon: string
): Promise<string> => {
  const { REACT_APP_API_URL } = process.env;

  try {
    const response = await fetch(`${REACT_APP_API_URL}/categories/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: auth,
      },
      body: JSON.stringify({
        name: categoryName,
        icon: icon,
        color: '#5e6061',
        local: true,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      return 'Category successfully added';
    } else {
      return data.message || 'Error adding category';
    }
  } catch (error) {
    return (error as Error).message || 'Unknown error';
  }
};
